import classnames from 'classnames';

import Code from '@/components/renderers/CodeBlock';
import { usePlaygroundState } from './context';
import { Tabs, TabsItem } from './Tabs';

export default function PlaygroundItems({ items }) {
  const { activeSection } = usePlaygroundState();

  return items.map((item, index) => {
    const isActive = item === activeSection;

    return (
      <div
        className={classnames({ hidden: !isActive, block: isActive })}
        key={index}
      >
        {(item.response || item.query) && (
          <Tabs>
            <TabsItem label="Query" className="h-84">
              <Code className="graphql" noCopy>
                {item.query}
              </Code>
            </TabsItem>
            <TabsItem label="Response" className="h-84">
              <Code className="json" noCopy>
                {item.response}
              </Code>
            </TabsItem>
          </Tabs>
        )}

        {item?.code?.language && item?.code?.content && (
          <div className="h-[386px]">
            <Code className={item.code.language} noCopy>
              {item.code.content}
            </Code>
          </div>
        )}
      </div>
    );
  });
}
